const isYouTubeLink = (str: string) => {
  const pattern = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
  return pattern.test(str);
};

export default isYouTubeLink;
